import { render } from "./WhaleRichView.vue?vue&type=template&id=56b67f0b&scoped=true"
import script from "./WhaleRichView.vue?vue&type=script&lang=js"
export * from "./WhaleRichView.vue?vue&type=script&lang=js"

import "./WhaleRichView.vue?vue&type=style&index=0&id=56b67f0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b67f0b"]])

export default __exports__